import React from "react";
import Fan from "../../../assets/img/custom/PinClipart1.png";
import Athlete from "../../../assets/img/custom/balls.png";
import nilWavier from "../../../assets/img/custom/NILWAIVER.jpg";
import wavierAgreement from "../../../pdf/WAIVERAGREEMENTFHP.docx";
import notice from "../../../assets/img/custom/599Notice.png";

export default function HomeUserCards({
  registerNoticeToggle,
  toggleGameDayStay,
  toggleFhpCoinToken,
}) {

  return (
    <div className="mb-3 pb-4 px-4">
      <h2 className="auth-heading text-center mt-3 mb-4">I am a</h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "32px",
        }}
      >
        {/* ── Athlete ── */}
        <div
          style={{
            flex: "1 1 300px",
            maxWidth: "420px",
            minWidth: "280px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "1px solid #e0e0e0",
            borderRadius: "16px",
            padding: "24px 20px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
          }}
        >
          <img
            src={nilWavier}
            alt="NIL Waiver"
            style={{ width: "100%", maxWidth: "320px", borderRadius: "8px" }}
          />

          <div className="d-flex justify-content-center gap-2 mt-3 w-100" style={{ gap: "8px" }}>
            <a
              className="btn btn-primary flex-fill"
              href="https://youtube.com/shorts/84ga4Tlwy34?feature=share"
              target="_blank"
              rel="noopener noreferrer"
            >
              Video1
            </a>
            <a
              className="btn btn-primary flex-fill"
              href="https://youtube.com/shorts/je2q5InFkP8"
              target="_blank"
              rel="noopener noreferrer"
            >
              Video2
            </a>
          </div>

          <a
            className="btn btn-primary mt-2 w-100"
            href={wavierAgreement}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            Download
          </a>

          <a
            href="https://youtu.be/AgE3ee33jD8"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 small"
          >
            https://youtu.be/AgE3ee33jD8
          </a>

          <h2
            className="font-weight-bold text-center mt-3 mb-0"
            style={{ color: "red", fontSize: "2.2rem", lineHeight: "1" }}
          >
            Open
          </h2>
          <h2 className="auth-heading text-center mt-1">
            Athlete <br /> (Free Sign-Up)
          </h2>

          <img
            src={Athlete}
            className="pointer mt-2"
            onClick={registerNoticeToggle}
            alt="Athlete"
            style={{ width: "100%", maxWidth: "320px", borderRadius: "8px" }}
          />

          <a
            className="btn btn-primary px-4 mt-3 w-100"
            href="https://youtube.com/shorts/89wO2L_E0h4"
            target="_blank"
            rel="noopener noreferrer"
          >
            Athlete BOOST NIL
          </a>
        </div>

        {/* ── Only Fan + Manager ── */}
        <div
          style={{
            flex: "1 1 300px",
            maxWidth: "420px",
            minWidth: "280px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "1px solid #e0e0e0",
            borderRadius: "16px",
            padding: "24px 20px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
          }}
        >
          <a
            href="https://youtu.be/37kKe6g6eJs"
            target="_blank"
            rel="noreferrer"
            className="small mb-3"
          >
            https://youtu.be/37kKe6g6eJs
          </a>

          <h4 className="auth-heading text-center mb-2" style={{ fontSize: "1.6rem", whiteSpace: "nowrap" }}>
            Only Fan + Manager
          </h4>

          <h2
            style={{
              color: "red",
              fontSize: "2.2rem",
              fontWeight: "bold",
              lineHeight: "1",
              margin: "0 0 12px 0",
              textAlign: "center",
            }}
          >
            Open
          </h2>

          <a
            href={
              process.env.REACT_APP_ENV === "production"
                ? "https://fhp-fans-production.web.app"
                : "https://fhp-fans.web.app/"
            }
            target="_blank"
            rel="noreferrer"
            style={{ display: "block", width: "100%", textAlign: "center" }}
          >
            <img
              src={Fan}
              alt="Fan"
              style={{
                height: "300px",
                maxWidth: "100%",
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
            />
          </a>
        </div>
      </div>

    </div>
  );
}
